export const WHEEL_SIZE = {
  base: 350, 
  md: 372,
  lg: 520
};

export const WHEEL_CENTER_SIZE = { 
  base: 240, 
  md: 255,
  lg: 356
}